// src/App.js

import React from "react";
import { Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./components/auth/authConfig"; // MSAL instance
import Login from "./components/auth/SigninWidget"; // Your login component
import ExitKTDetails from "./components/pages/ExitKTDetails.tsx";
import InformationProvided from "./components/pages/InformationProvided.tsx";
import DocumentAccess from "./components/pages/DocumentAccess.tsx";
import WelcomeInterview from "./components/pages/WelcomeInterview";
import SideMenu from "./components/nav/SideMenu.jsx";
import ManagerDashboard from "./components/pages/ManagerDashboard.tsx";
import EmployeeDashboard from "./components/pages/EmployeeDashboard.tsx";
import UserManagement from "./components/pages/UserManagement.tsx";

const App = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <Routes>
        {/* Login Page */}
        <Route path="/" element={<Login />} />

        {/* KT Process Pages wrapped in SideMenu */}
        <Route
          path="/exit-kt-details/:employeeId"
          element={
            <SideMenu text="Exit KT Details">
              <ExitKTDetails />
            </SideMenu>
          }
        />
        <Route
          path="/information-provided/:ktId"
          element={
            <SideMenu text="Information Provided">
              <InformationProvided />
            </SideMenu>
          }
        />
        <Route
          path="/document-access/:ktId"
          element={
            <SideMenu text="Document Access">
              <DocumentAccess />
            </SideMenu>
          }
        />
        <Route
          path="/welcome-interview"
          element={
            <SideMenu text="Interview Sessions">
              <WelcomeInterview />
            </SideMenu>
          }
        />

        <Route
          path="/manager-dashboard"
          element={
            <SideMenu text="Manager Overview">
              <ManagerDashboard />
            </SideMenu>
          }
        />

        <Route
          path="/employee-dashboard"
          element={
            <SideMenu text="Employee Overview">
              <EmployeeDashboard />
            </SideMenu>
          }
        />

        <Route
          path="/admin-dashboard"
          element={
            <SideMenu text="Admin Dashboard">
              <UserManagement />
            </SideMenu>
          }
        />
      </Routes>




    </MsalProvider>
  );
};

export default App;
